// extracted by mini-css-extract-plugin
export default {"info":"style_info__OQEQm","avatar":"style_avatar__Qji53"};